export const FETCH_TEAM_TEMPLATE_SIZES_REQUEST =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/FETCH_REQUEST";
export const FETCH_TEAM_TEMPLATE_SIZES_SUCCESS =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/FETCH_SUCCESS";
export const FETCH_TEAM_TEMPLATE_SIZES_FAILURE =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/FETCH_FAILURE";

export const CREATE_TEAM_TEMPLATE_SIZE_REQUEST =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/CREATE_REQUEST";
export const CREATE_TEAM_TEMPLATE_SIZE_SUCCESS =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/CREATE_SUCCESS";
export const CREATE_TEAM_TEMPLATE_SIZE_FAILURE =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/CREATE_FAILURE";

export const UPDATE_TEAM_TEMPLATE_SIZE_REQUEST =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/UPDATE_REQUEST";
export const UPDATE_TEAM_TEMPLATE_SIZE_SUCCESS =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/UPDATE_SUCCESS";
export const UPDATE_TEAM_TEMPLATE_SIZE_FAILURE =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/UPDATE_FAILURE";

export const DELETE_TEAM_TEMPLATE_SIZE_REQUEST =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/DELETE_REQUEST";
export const DELETE_TEAM_TEMPLATE_SIZE_SUCCESS =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/DELETE_SUCCESS";
export const DELETE_TEAM_TEMPLATE_SIZE_FAILURE =
  "API/ENTITIES/TEAM_TEMPLATE_SIZES/DELETE_FAILURE";
